import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery, useMutation, gql } from '@apollo/client';
import { connect } from 'react-redux';

import LikeProductHeart from './LikeProductHeart';

const Wrapper = styled.div`
  .like-product-container {
    background: #f5f5f5;
    height: 45px;
    width: 45px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin-bottom: 0;
    }
  }
`;

// props taken props.productId, props.productSlug, props.productName
function Heart(props) {
  const [favorite, setFavorite] = useState(false);
  const { loading, data, error } = useQuery(
    ALL_LIKED_PRODUCTS_BY_CURRENT_USER,
    {
      skip: !props.isAuthenticated
    }
  );

  const isProductLiked = data => {
    const findIdx = data.findIndex(product => product.id == props.productId);
    if (findIdx !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const [mutation] = useMutation(
    isProductLiked(data ? data.allLikedProductsByCurrentUser : [])
      ? UNLIKE_PRODUCT
      : LIKE_PRODUCT,
    {
      variables: {
        product_id: props.productId
      },
      optimisticResponse() {
        return isProductLiked(data ? data.allLikedProductsByCurrentUser : [])
          ? {
              __typename: 'Mutation',
              unlikeProduct: {
                id: props.productId,
                slug: props.productSlug,
                name: props.productName,
                __typename: 'Product'
              }
            }
          : {
              __typename: 'Mutation',
              likeProduct: {
                id: props.productId,
                slug: props.productSlug,
                name: props.productName,
                __typename: 'Product'
              }
            };
      },
      update(cache, { data }) {
        const { allLikedProductsByCurrentUser } = cache.readQuery({
          query: ALL_LIKED_PRODUCTS_BY_CURRENT_USER
        });

        if (isProductLiked(allLikedProductsByCurrentUser)) {
          const likedProducts = [...allLikedProductsByCurrentUser];
          const index = likedProducts.findIndex(
            product => product.id == props.productId
          );
          likedProducts.splice(index, 1);
          cache.writeQuery({
            query: ALL_LIKED_PRODUCTS_BY_CURRENT_USER,
            data: {
              allLikedProductsByCurrentUser: [...likedProducts]
            }
          });
        } else {
          const newData = [...allLikedProductsByCurrentUser, data.likeProduct];

          cache.writeQuery({
            query: ALL_LIKED_PRODUCTS_BY_CURRENT_USER,
            data: {
              allLikedProductsByCurrentUser: [...newData]
            }
          });
        }
      }
    }
  );

  if (loading) return '';
  if (error) {
    return `Error ${error}`;
  }
  return (
    <Wrapper>
      <div className="like-product-container">
        <LikeProductHeart
          isAuthenticated={props.isAuthenticated}
          mutation={mutation}
          favorite={isProductLiked(
            data ? data.allLikedProductsByCurrentUser : []
          )}
          setFavorite={setFavorite}
        />
      </div>
    </Wrapper>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated
  };
};

const mapDispatchToProps = dispatch => ({});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(Heart);

const UNLIKE_PRODUCT = gql`
  mutation unlikeProduct($product_id: ID!) {
    unlikeProduct(product_id: $product_id) {
      id
      name
      slug
    }
  }
`;

const LIKE_PRODUCT = gql`
  mutation likeProduct($product_id: ID!) {
    likeProduct(product_id: $product_id) {
      id
      name
      slug
    }
  }
`;

const ALL_LIKED_PRODUCTS_BY_CURRENT_USER = gql`
  query allLikedProductsByCurrentUser {
    allLikedProductsByCurrentUser {
      id
      sku
      slug
      name
    }
  }
`;
